<div class="booking-activation-dialog">
  <div class="dialog-header">
    <h2 class="dialog-title">Activar Reservas PRO</h2>
    <p class="dialog-subtitle">Suscripción con prueba gratuita</p>
  </div>

  <div class="dialog-body">
    <div class="trial-info-box">
      <div class="trial-highlight">
        <mat-icon class="trial-icon">card_giftcard</mat-icon>
        <div class="trial-text">
          <h3>Prueba Gratis</h3>
          <p class="trial-period">Hasta el {{ getFormattedTrialEndDate() }}</p>
        </div>
      </div>
    </div>

    <div class="pricing-info">
      <div class="pricing-label">Después de la prueba:</div>
      <div class="pricing-row">
        <span class="pricing-period">Mensual</span>
        <span class="pricing-amount">{{ monthlyPrice | number:'1.2-2' }}€ <span class="pricing-unit">/mes</span></span>
      </div>
    </div>

    <div class="benefits-section">
      <h4>Incluye:</h4>
      <ul class="benefits-list">
        <li><mat-icon>done</mat-icon><span>Gestión completa de reservas</span></li>
        <li><mat-icon>done</mat-icon><span>Calendario integrado</span></li>
        <li><mat-icon>done</mat-icon><span>Sistema de confirmación automática</span></li>
        <li><mat-icon>done</mat-icon><span>Notificaciones en tiempo real</span></li>
      </ul>
    </div>

    <div class="conditions-note">
      <p>Puedes cancelar tu suscripción en cualquier momento. Sin permanencia mínima.</p>
    </div>
  </div>

  <div class="dialog-actions">
    <button mat-button (click)="onCancel()" class="btn-cancel">Cancelar</button>
    <button mat-raised-button (click)="onConfirm()" class="btn-confirm">
      Activar prueba gratis
    </button>
  </div>
</div>
